import PageContext from 'global_state/context/PageContext'

import { useContext, useEffect, useState } from 'react'
import FormSCSS from '../assets/scss/Form.module.scss'
import AppSCSS from 'assets/scss/App.module.scss'
import Title from './Title'
import { updateUserAccountService } from 'services/user_services/UpdateUserAccountService'
import UserContext from 'global_state/context/UserContext'
import { PageType } from 'types/PageI'
import DateInput from './form/DateInput'
import content from 'languages/AccountDetail.json'

function AccountDetail() {
    const {page, dispatchPage}  = useContext(PageContext)
    const {user, dispatchUser} = useContext(UserContext)
    let lang = page.settings.language

    let required_fields = ['x_first_name', 'x_last_name', 'x_phone_number', 'x_email', 'x_password', 'x_business_conditions']
    const editable_data = ['x_date_of_birth', 'x_phone_number', 'x_address', 'x_email']
    
    const [edit_data_response, setEditDataResponse] = useState<any>()
    const [user_data, setUserData] = useState({
        x_first_name: '',
        x_last_name: '',
        x_date_of_birth: '',
        x_phone_number: '',
        x_address: '',
        x_email: '',
        // x_password: ""
    })
    const [user_data_errors, setUserDataErrors] = useState({
        x_first_name: false,
        x_last_name: false,
        x_date_of_birth: false,
        x_phone_number: false,
        x_address: false,
        x_email: false,
    })

    useEffect(() => {
        // console.log(user);
        var non_empty_address = user.address.filter(el => {
            return el != null;
        });

        let date = new Date(user.birth_date)
        var birth_date =  [
            String(date.getUTCFullYear()),
            String((date.getUTCMonth() + 1)),
            String(date.getUTCDate())
        ].join('-')

        setUserData({
            ...user_data,
            x_first_name: user.first_name,
            x_last_name: user.second_name,
            x_date_of_birth: birth_date,
            x_phone_number: user.phone, 
            x_address: non_empty_address.join(','),
            x_email: user.email
        })
    }, [user])

    useEffect(() => {
        // console.log(edit_data_response);
        if (edit_data_response == undefined) {
            return 
        }
        if (typeof edit_data_response == 'string') {
            // TODO: notification
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "general_error"
                    }
                }
            })
            return 
        }

        dispatchUser({
            type: "update_user_account",
            payload: edit_data_response
        })
        dispatchPage({
            type: "add_notification",
            payload: {
                notification: {
                    type: "success",
                    message: "account_detail_updated_successfully"
                }
            }
        })
        

    }, [edit_data_response])
    
    const isErrorInDateInput = () => {
        // console.log("user_data['x_date_of_birth']");
        // console.log(user_data['x_date_of_birth']);
        
        
        if (user_data['x_date_of_birth'] != '' && user_data['x_date_of_birth'] != null) {
            // save only full date 
            // console.log("x_date_of_birth included".toUpperCase());
            // console.log(user_data['x_date_of_birth']);
            // console.log(typeof user_data['x_date_of_birth']);
            
            let parts = user_data['x_date_of_birth'].split('-')
            // console.log(parts);
            
            if (parts.length < 3) {
                return true
            }

            let has_empty = parts.some((value) => value == '')
            let all_empty = parts.every((value) => value == '')
            
            if (has_empty && !all_empty) {
                return true
            }

            if (parseInt(parts[2]) <= 0 || parseInt(parts[2]) > 31) {
                return true
            }
            if (parseInt(parts[1]) <= 0 || parseInt(parts[1]) > 12) {
                return true
            }
            if (parseInt(parts[0]) < 1900 || parseInt(parts[0]) > new Date().getUTCFullYear()) {
                return true
            }
        }
        return false
    }
    const handleSubmit = async (event) => {
        event.preventDefault()

        let editable_user_data = {}
        editable_data.forEach(el => {
            editable_user_data[el] = user_data[el]
        })
        
        let error_resonse = false
        let errors = {}

        if (isErrorInDateInput()) {
            errors['x_date_of_birth'] = true
            error_resonse = true
        }
        Object.keys(editable_user_data).forEach(key => {
            // console.log(key);
            if (required_fields.includes(key)){
                if ((editable_user_data[key] == false) || (editable_user_data[key] == '')) {
                    errors[key] = true
                    error_resonse = true
                }
            }
        })
        
        
        // console.log(error_resonse);
        // console.log(user_data_errors);
        // console.log(errors);
        
        if (error_resonse) {
            setUserDataErrors({...user_data_errors, ...errors})
            // TODO: hadnle if error before update on server
            // console.log("HANDLE ERRORS");
            dispatchPage({
                type: "add_notification",
                payload: {
                    notification: {
                        type: "error",
                        message: "items_required"
                    }
                }
            })
            
            return 
        }

        // console.log("UPDATE USER DETAIL");
        setEditDataResponse(await updateUserAccountService(editable_user_data, user.email))
    }
    const getInputValue = (key, value) => {
        // if (key == 'x_date_of_birth' && (value != null || value != '') ) {
        //     let date = new Date(value)
        //     return [
        //         String(date.getDate()),
        //         String((date.getMonth() + 1)),
        //         String(date.getFullYear())
        //     ].join('.')
        // }
        // if (key == 'x_address') {
        //     // return value.join(',')
        //     var filtered = value.filter(el => {
        //         return el != null;
        //     });
        //     return filtered.join(',')
        // }
        return value
    }
    const getInputType = (key) => {
        // if (key == 'x_date_of_birth') {
        //     return 'date'
        // }
        return 'text'
    }
    const setInputData = (key, value) => {
        // if (key == 'x_address') {
        //     // let splits = value.split(',')
        //     return 
        // }
        // console.log(key, value);
        
        {setUserData({
            ...user_data,
            [key]: value 
        })}
    }
    const renderRequiredField = (field_name: string) =>  {
        if (!(required_fields.includes(field_name))) {
            return ''
        }

        return ' *'
    }
    const renderErrorClass = (key) => {
        if (user_data_errors[key] == true) {
            return FormSCSS.input_error
        }
        return ''
    }

    const renderInput = (key) => {
        if (key == 'x_date_of_birth') {
            return (
                <DateInput
                    readOnly={!(editable_data.includes(key))}
                    className={renderErrorClass(key)}
                    id={key}
                    name={key}
                    value={getInputValue(key, user_data[key])}
                    onChange={(field, value) => { setInputData(field, value) }}
                    onFocus={(field) => setUserDataErrors({...user_data_errors, [field]: false})}
                />
            )
        }


        return (
            <label htmlFor={key} className={FormSCSS.label}>
                <input 
                    placeholder={content[lang][key + '_placeholder'] + renderRequiredField(key)}
                    readOnly={!(editable_data.includes(key))}
                    className={[FormSCSS.input, renderErrorClass(key)].join(' ')} 
                    type={getInputType(key)} 
                    id={key}
                    name={key}
                    value={getInputValue(key, user_data[key])}
                    onChange={e => setInputData(key, e.target.value)}
                    onFocus={(e) => setUserDataErrors({...user_data_errors, [key]: false})}
                />
            </label>     
        )
    }
    const renderFields = () => {
        return Object.keys(user_data).map(key => {
            return (
                <div className={FormSCSS.label_with_span}>
                    <span className={FormSCSS.label_span}>{content[lang][key]}</span>
                    {renderInput(key)}
                </div>
            )
        })
    }

    return (
        <div className={FormSCSS.Form_SCSS}>
            <Title back_arrow={true} back_arrow_text={content[lang].title_text_back} page={PageType.user_profile} title={content[lang].title_text}/>
            <form className={FormSCSS.form} onSubmit={handleSubmit}>
                {renderFields()}
                <button 
                    className={[AppSCSS.button, AppSCSS.red].join(" ")}
                    type="submit">
                        {content[lang].submit_button}
                </button>
            </form>
        </div>
    )
}
export default AccountDetail